<template>
  <span
    class="user-avatar"
    :style="avatarStyle"
    :aria-label="`${displayName}的头像`"
  >
    <img
      v-if="displaySrc && !loadFailed"
      :src="displaySrc"
      :alt="`${displayName}的头像`"
      decoding="async"
      referrerpolicy="no-referrer"
      @error="loadFailed = true"
    />
    <span v-else aria-hidden="true">{{ initial }}</span>
  </span>
</template>

<script setup>
/* global defineProps */
import { computed, ref, watch } from 'vue';

const props = defineProps({
  src: {
    type: String,
    default: '',
  },
  name: {
    type: String,
    default: '用户',
  },
  size: {
    type: Number,
    default: 48,
  },
});

const loadFailed = ref(false);
const displayName = computed(() => props.name.trim() || '用户');
const initial = computed(() => Array.from(displayName.value)[0]?.toUpperCase() || 'U');
const displaySrc = computed(() => props.src.trim());
const avatarStyle = computed(() => ({
  width: `${props.size}px`,
  height: `${props.size}px`,
  fontSize: `${Math.max(props.size * 0.34, 14)}px`,
}));

watch(displaySrc, () => {
  loadFailed.value = false;
});
</script>

<style scoped>
.user-avatar {
  display: inline-grid;
  flex: 0 0 auto;
  overflow: hidden;
  place-items: center;
  border: 1px solid rgba(37, 99, 235, 0.18);
  border-radius: 50%;
  color: #1d4ed8;
  background: linear-gradient(145deg, #eff6ff, #eef2ff);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);
  font-weight: 700;
}

.user-avatar img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
